import Link from "@components/Link";
import ThickChinaAvatarIcon from "@src/app/assets/author-placeholder.svg";
import type { BFFArticleCard, BFFAuthorDetail } from "@src/app/types/bff";
import cx from "classnames";
import type { ReactElement } from "react";

type Props = Readonly<{
  author: BFFArticleCard["authors"][0] | BFFAuthorDetail;
  size?: "small" | "large";
  className?: string;
}>;

export default function Byline({
  author,
  size = "large",
  className,
  ...props
}: Props): ReactElement {
  return (
    <Link
      data-testid={`byline-${author.id}`}
      to={author.urlPath || ""}
      className={cx(
        "group text-label-2 text-primary flex items-start gap-2",
        className,
      )}
      {...props}
    >
      <img
        src={author.imageUrl || ThickChinaAvatarIcon}
        alt={author.name}
        className={cx("rounded-full", {
          "size-8": size === "small",
          "size-10": size === "large",
        })}
      />

      <div>
        <div className={cx("text-label-1 font-bold")}>
          <span className="text-tertiary dark:text-secondary-on-dark">By</span>
          <span className="group-hover:text-link-hover text-link-default dark:text-primary-on-dark group-hover:cursor-pointer">
            {" "}
            {author.name}
          </span>
        </div>
        {author.designation && (
          <span
            className={cx(
              "text-label-1 text-tertiary dark:text-secondary-on-dark block font-bold",
            )}
          >
            {author.designation}
          </span>
        )}
      </div>
    </Link>
  );
}
